import { EditViewEnum } from '../models/edit-view.enum';
import { CanvasSizeModel } from '../models/canvas-size.model';

export class EditStateModel {
    view: EditViewEnum;
    showColumns: boolean;
    showLeftColumn: boolean;
    showRightColumn: boolean;
    showHeader: boolean;
    showFooter: boolean;
    autoCapture: boolean;
    record: boolean;
    layerOrderMode: boolean;
    showTreeNodeIds: boolean;

    canvasSize: CanvasSizeModel;
    canvasSettings: {
        emulateDrawer: boolean;
        emulateColumn: boolean;
    };
}
